import Navbar from "../components/Navbar";
import ClientList from "../components/Clients/ClientList";
import styles from "./Clients.module.scss";

const Clients = () => {
  return (
    <>
      <Navbar />
      <div className={styles.container}>
        <ClientList />
      </div>
    </>
  );
};

export default Clients;
